import React from "react";

import { createCtx } from "@phoenix/context/context";

import type { AlertPriorityGroup } from "../domains/tracking/generated/tracking";

export interface AlertStore {
  hasHighOrMediumPriorityAlerts: boolean;
  hiddenAlerts?: Array<number | string>;
  resetNotificationWindowList?: boolean;
  priority: AlertPriorityGroup | "All";
  selectedEventId?: string;
  declaration: {
    showDeclaration: boolean;
    alertCount: number;
  };
}

export const [useAlertContext, AlertContextProvider] = createCtx<AlertStore | undefined>();
const AlertActionsContext = React.createContext<(alertStore: Partial<AlertStore>) => void>(() => {});
export const useAlertActionsContext = (): ((alertStore: Partial<AlertStore>) => void) => {
  const context = React.useContext(AlertActionsContext);
  if (context === undefined) {
    throw new Error(`Context must be called within Provider`);
  }
  return context;
};

type Props = { children: React.ReactNode };

export const AlertProvider = ({ children }: Props): React.ReactElement => {
  const [alertStore, setAlertStore] = React.useState<AlertStore>({
    hasHighOrMediumPriorityAlerts: false,
    resetNotificationWindowList: false,
    priority: "All",
    hiddenAlerts: [],
    declaration: {
      showDeclaration: false,
      alertCount: 0,
    },
  });

  return (
    <AlertContextProvider value={alertStore}>
      <AlertActionsContext.Provider
        value={(store: Partial<AlertStore>) =>
          setAlertStore((prev: $TSFixMe) => ({
            ...prev,
            ...store,
          }))
        }
      >
        {children}
      </AlertActionsContext.Provider>
    </AlertContextProvider>
  );
};
